import { getOwner } from '@ember/application';

function getConfig(context) {
  return getOwner(context).resolveRegistration('config:environment');
}

export { getConfig as default };
//# sourceMappingURL=get-config.js.map
